<div class="grid grid-cols-2 gap-x-10 gap-y-2">
    <div class="grid grid-cols-2 gap-x-5 gap-y-2">
        <b>chæmp-ID</b>
        <span>{{ groupChangeRequest?.employeeChaempId ?? employee?.chaempId }}</span>

        <b i18n>Employee-no.</b>
        <span>{{ groupChangeRequest?.employeeNumber ?? employee?.employeeNumber }}</span>

        <b i18n>Alternative Employee-no.</b>
        <span>{{ groupChangeRequest?.employeeAlternativeNumber ?? employee?.alternativeEmployeeNumber }}</span>

        <b i18n>Date of birth</b>
        <span>{{ groupChangeRequest?.employeeDateOfBirth ?? employee?.dateOfBirth | date: 'dd.MM.yyyy' }}</span>

        <b i18n>Office</b>
        <span>{{ groupChangeRequest?.employeeOfficeName ?? employeeOfficeName }}</span>
    </div>
    <div class="grid grid-cols-2 gap-x-5 gap-y-2">
        <b i18n>Active group</b>
        <span>{{ groupChangeRequest?.previousEmployeeGroup ?? employee?.employeeGroup }}</span>

        <b i18n>Active group effective since</b>
        <span>{{ groupChangeRequest?.employeeGroupEffectiveSince ?? employee?.employeeGroupEffectiveSince | date: 'dd.MM.yyyy' }}</span>
    </div>
</div>
